
import {
  SET_AVAILABLECLASS,
  CREATE_AVAILABLECLASS,
  AVAILABLECLASSS_RECEIVED,
  SET_PROPERTY_AVAILABLECLASS,
} from "../types/available_classes";

const schema = {

}

const availableClasssReducer = (state, { type, payload }) => {
  switch (type) {
    case AVAILABLECLASSS_RECEIVED:
      return { ...state, available_classes: payload };
    case SET_AVAILABLECLASS:
      return { ...state, availableClass: payload };
    case CREATE_AVAILABLECLASS:
      return { ...state, availableClass: schema };
    case SET_PROPERTY_AVAILABLECLASS: {
      const { key, value } = payload;
      const availableClass = { ...state.availableClass };
      availableClass[key] = value;
      return { ...state, availableClass };
    }
    default:
      return { ...state};
  }
};

export default availableClasssReducer;
